import React, { useContext } from 'react'
import Button from '@material-ui/core/Button'
import RequestPaymentDialog from 'components/request-payment-dialog'
import { RefetchContext } from 'lib/utils/refetchContext'
import Typography from '@material-ui/core/Typography'
import RemindOrCancelRequestPaymentDialog from 'components/remind-or-cancel-request-payment-dialog'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'

const CollectPaymentDialog = ({ event, enrollment }) => {
  const refetch = useContext(RefetchContext)
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))

  const { paymentAccount } = event || {}
  const { deletedAt, chargesEnabled } = paymentAccount || {}
  const isPaymentAccountValid = paymentAccount && !deletedAt && chargesEnabled

  if (
    !enrollment ||
    !event ||
    event.priceInCents <= 0 ||
    !event.acceptsOnlinePayments ||
    !isPaymentAccountValid
  ) {
    return null
  }

  const canSendPaymentRequestReminder = !enrollment.paymentRequestedDate

  return canSendPaymentRequestReminder ? (
    <RequestPaymentDialog
      trigger={
        <Button color="primary" size="small" data-testid="collect-payment">
          Collect Payment
        </Button>
      }
      onPaymentSuccess={() => {
        refetch()
      }}
      enrollment={{
        category: 'GROUP',
        startDateTime: event.startDateTime,
        endDateTime: event.endDateTime,
        priceInCents: event.priceInCents,
        timezone: event.timezone,
        title: event.title,
        ...enrollment,
      }}
    />
  ) : (
    <Box
      display="flex"
      flexDirection="column"
      alignItems={isMobile ? 'flex-start' : 'center'}
      justifyContent="center"
      mt={isMobile ? 2 : 0}
    >
      <Typography variant="body2" color="textPrimary" gutterBottom>
        Still waiting on a payment? Remind your student to submit their payment
        online
      </Typography>
      <Box display="flex" justifyContent="space-around">
        <RemindOrCancelRequestPaymentDialog
          trigger={
            <Button color="primary" size="small">
              Cancel
            </Button>
          }
          onSuccess={() => refetch()}
          enrollmentId={enrollment.id}
          isCancelReminder={true}
        />
        <RemindOrCancelRequestPaymentDialog
          trigger={
            <Button color="primary" variant="outlined" size="small">
              Remind
            </Button>
          }
          onSuccess={() => refetch()}
          enrollmentId={enrollment.id}
          isCancelReminder={false}
        />
      </Box>
    </Box>
  )
}

export default CollectPaymentDialog
